const shotBlockPlayerSelectActions = [
  {
    actions: [
      { action: "saveData", value: "block", type: "eventType" },
      {
        action: "clearData",
        value: ["options", "subType", "scores", "success"],
        type: "main",
      },
      { action: "sendEvent", value: "new", type: "main" },
      {
        action: "setPossession",
        value: { currentEntity: false },
        type: "main",
      },
    ],
    conditions: [],
  },
  {
    actions: [
      { action: "copyEvent", value: "shot", type: "from" },
      { action: "nextState", value: "defence-goalkeeper", type: "primary" },
    ],
    conditions: [
      { item: "isInsertMode" },
    ],
  },
  {
    actions: [
      { action: "nextState", value: null, type: "primary" },
    ],
  },
];

export const ShotBlockPlayerSelect = {
  name: "shot-block-player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "block.select-player",
  showOn: [{ state: "primary", value: "shot-block-player", operator: "is" }],
  allowBack: { state: "primary", value: "shot-player", event: "shot" },
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  showDetails: { events: ["main"] },
  children: [
    {
      name: "shot-block-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      startEvent: true,
      startPlay: false,
      options: { currentEntity: false, showBench: false, showCoach: false },
      actionGroups: shotBlockPlayerSelectActions,
    },
    {
      name: "confirm-later-shot-block-player",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: "confirmLater",
      showOn: [true],
      startEvent: true,
      startPlay: false,
      options: { currentEntity: true },
      actionGroups: [
        {
          actions: [
            { action: "saveData", type: "flagged", value: true },
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [],
        },
        ...shotBlockPlayerSelectActions,
      ],
    },
  ],
};
